import { OrderMembershipPriceApiModel } from '../../../api-model/order/order-membership-price.api.model';
import { GadgetItemApiModel } from '../../../api-model/order/gadget-item/gadget-item.api.model';
import { AbstractViewModel } from '../../../abstract.view.model';
import { OrderMembershipPriceViewModel } from '../order-membership-prices.view.model';

export class GadgetItemViewModel extends AbstractViewModel<GadgetItemApiModel> {
  id: string;
  itemId: string;
  name: string;
  quantity: number;
  taxRate: number;
  price: number;
  value: number;
  defaultPriceLevelPrice: number;
  itemEarnedPoints: number;
  itemRedemptionPoints: number;
  voucherNumber: string;
  voucherName: string;
  promotionId: string;
  promotionName: string;
  discountName: string;
  noDiscountPrice: number;
  discountValue: number;
  membershipPrices: OrderMembershipPriceApiModel[];
  graphics: string[];

  constructor(protected apiModel: GadgetItemApiModel = new GadgetItemApiModel()) {
    super(apiModel);
    this.fromApiModel();
  }

  protected fromApiModel(): void {
    this.id = this.apiModel.id;
    this.itemId = this.apiModel.itemId;
    this.name = this.apiModel.name;
    this.quantity = this.apiModel.quantity;
    this.taxRate = this.apiModel.taxRate;
    this.price = this.apiModel.price;
    this.value = this.apiModel.value;

    this.defaultPriceLevelPrice = this.apiModel.defaultPriceLevelPrice;
    this.itemEarnedPoints = this.apiModel.itemEarnedPoints;
    this.itemRedemptionPoints = this.apiModel.itemRedemptionPoints;
    this.voucherNumber = this.apiModel.voucherNumber;
    this.voucherName = this.apiModel.voucherName;
    this.promotionId = this.apiModel.promotionId;
    this.promotionName = this.apiModel.promotionName;
    this.discountName = this.apiModel.discountName;
    this.noDiscountPrice = this.apiModel.noDiscountPrice;
    this.discountValue = this.apiModel.discountValue;
    this.graphics = this.apiModel.graphics;

    this.membershipPrices = this.apiModel.membershipPrices.map((membershipPrice) => new OrderMembershipPriceViewModel(membershipPrice));
  }

  toApiModel(): GadgetItemApiModel {
    return undefined;
  }

  get graphicUrl(): string {
    return this.graphics && this.graphics.length > 0 ? this.graphics[0] : null;
  }
}
